export default {"src":"/_next/static/media/warning-icon-triangle.fbfb2c79.svg","height":15,"width":16};